export default __webpack_public_path__ + "static/media/Mangerica-Regular.f75538a4.otf";